"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteNavTabletLinks = void 0;
const react_1 = __importStar(require("react"));
const shared_1 = require("../../shared");
const atoms_1 = require("../atoms");
const menu_1 = require("../menu");
const tray_1 = require("../tray");
const SiteNavMobileLinks_1 = require("./SiteNavMobileLinks");
const SiteNavTabletLinks = ({ links = [], locale = "en-US", topOffset, burgerCallback, }) => {
    const menuId = "sitenav-tablet";
    const { mobileMenuOpen, setMobileMenuOpen } = (0, shared_1.useMobileMenu)();
    const { setInnerMobileMenu } = (0, shared_1.useInnerMobileMenu)();
    const setTabletTray = (0, react_1.useCallback)((menuopen) => {
        //close the inner tray
        setInnerMobileMenu("");
        setMobileMenuOpen(menuopen);
        if (burgerCallback && typeof burgerCallback === "function") {
            burgerCallback(menuopen);
        }
    }, [burgerCallback]);
    const toggleMobileMenu = (0, shared_1.useToggleMenu)(mobileMenuOpen, setTabletTray, menuId);
    return (react_1.default.createElement(menu_1.Menu, { role: "menu", static: true },
        mobileMenuOpen ? react_1.default.createElement(SiteNavMobileLinks_1.HideOverflow, null) : "",
        react_1.default.createElement(menu_1.DropdownSummary, { menuId: "tablet-burger", openMenu: toggleMobileMenu, onKeyUp: toggleMobileMenu },
            react_1.default.createElement(atoms_1.Burger, { menuOpen: mobileMenuOpen })),
        react_1.default.createElement(tray_1.LinksTrayWrap, { menuOpen: mobileMenuOpen },
            react_1.default.createElement(tray_1.LinksTray, { menuOpen: mobileMenuOpen }, links.map((link, i) => {
                if (link.isBarDivider)
                    return null;
                const key = link.key || `tablet-tray-menu-${i}`;
                return (react_1.default.createElement(tray_1.TabletTrayMenu, { key: `tray-item-${key}`, trayId: key, parentMenuOpen: mobileMenuOpen, link: link, locale: locale }));
            }))),
        react_1.default.createElement(tray_1.MobileTrayOverlay, { topOffset: topOffset })));
};
exports.SiteNavTabletLinks = SiteNavTabletLinks;
//# sourceMappingURL=SiteNavTabletLinks.js.map